import React, { Component } from "react";
import { Accessor, ColorX, FilterX, GFunc, IconX, LocaleX } from "../../../STATIC";
import PropsType from "prop-types";
import styles from "./_style/filterizo";
import _ from "lodash";
import OneFilterSelector from "./_gears/OneFilterSelector";
import PopupListSelector from "../../Libs/PopupListSelector/PopupListSelector";
import FilterizoIconX from "./FilterizoIconX";
import { XText, HStack, VStack,  
  XButton, XIconButton } from "../../../_X";

/**
 * @augments {Component<Props, State>}
 */
class Filterizo extends Component {

  static propTypes = {
    filter: PropsType.any,
    onFilterChange: PropsType.func,
    onMounted: PropsType.func,
    addOns: PropsType.any,
    style: PropsType.any,
    bgColor: PropsType.string,
    textColor: PropsType.string,
    borderColor: PropsType.string,
    borderWidth: PropsType.number,
    miniMaxWidth: PropsType.oneOfType([PropsType.number, PropsType.string]),
    displayMode: PropsType.oneOf(["onlyIcon", "mini", "full"]),
    schema: PropsType.array,
    multiRules: PropsType.bool,
    typeIcon: PropsType.bool
  }

  static defaultProps = {
    filter: {
      rules: [],
      logic: "AND"
    },
    onFilterChange: null,
    onMounted: null,
    addOns: {},
    style: {},
    bgColor: ColorX.CSS("gambotBlue", 0.1),
    textColor: ColorX.CSS("gambotBlue"),
    borderColor: ColorX.CSS("gambotBlue"),
    borderWidth: 1,
    displayMode: "full",
    miniMaxWidth: 110,
    schema: [],
    multiRules: true,
    typeIcon: false
  }

  constructor(){
    super();
    this.state = {
      mounted: false,
      openAdv: false
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Filterizo.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), () => {
      if(this.props.onMounted && !this.state.mounted){
        this.props.onMounted({
          SetShowRules: this._setShowRules
        });
        this.setState({
          mounted: true
        });
      }
      callback?.();
    });
  }

  _onAddRule = (ischema) => {
    let {filter} = this.props;

    let defaultOper = FilterX.GetDefaultOper(ischema.format);
    let defaultValue = null;
    if(defaultOper === "isRelativeToToday"){
      defaultValue = {period: "this", unit: "week"};
    }

    let addFilter = {
      label: ischema.label,
      name: ischema.name,
      format: ischema.format,
      operator: defaultOper,
      value: defaultValue
    };

    let newFilter = null;
    if(_.isEmpty(filter)){
      newFilter = {
        rules: [addFilter],
        logic: "AND"
      };
    }else{
      newFilter = _.cloneDeep(filter);
      if(!newFilter.rules){
        newFilter.rules = [];
      }
      newFilter.rules.push(addFilter);
    }
    GFunc.CloseBackdrop();
    this._onFilterChange(newFilter);
  }

  _clearFilter = () => {
    this._onFilterChange({});
  }

  _setAndOr = () => {
    let {filter} = this.state;
    filter.logic = filter?.logic === "AND" ? "OR" : "AND";

    this._onFilterChange(filter);
  }

  _onFilterChange = (filter) => {
    let {onFilterChange} = this.props;
    onFilterChange?.(filter);
  }

  _openFieldSelector = () => {
    let {schema} = this.props;
    let _schema = _.filter(schema, o => o.hidden !== true);
    GFunc.Backdrop(() => {
      return (
        <PopupListSelector
          choices={_schema}
          onSelect={this._onAddRule}
          renderer={(choice) => {
            let {label, format} = choice;
            return (
              <HStack style={{padding: 10}}>
                <HStack style={styles.popbtnicon}>
                  {this.renderIcon(format)}
                </HStack>
                <XText style={styles.popbtntext}>
                  {LocaleX.Parse(label)}
                </XText>
              </HStack>
            );
          }}
          allowSearch={true}
          selectVal="name"
          searchFields={[
            "label.EN",
            "label.TC",
            "format",
            "name"
          ]}
          />
      );
    }, {}, true, true);
  }

  _editFilter = (newFilterBlock, idx) => {
    let {filter} = this.props;
    let newFilter = _.cloneDeep(filter);
    newFilter.rules[idx] = newFilterBlock;
    this._onFilterChange(newFilter);
  }

  _removeFilter = (idx) => {
    let {filter} = this.props;
    let newFilter = _.cloneDeep(filter);
    newFilter.rules = _.filter(newFilter.rules, (o, i) => i !== idx);
    this._onFilterChange(newFilter);
  }

  _openAdvFilter = () => {
    let {openAdv} = this.state;
    this.setState({
      openAdv: !openAdv
    });
  }

  _setShowRules = (open) => {
    this.setState({
      openAdv: open
    });
  }

  renderAdvFilter = () => {
    let {filter, addOns, schema, typeIcon} = this.props;
    return (
      <VStack style={styles.advpopup} spacing={2}>
        {_.map(filter?.rules, (o, i) => {
          let ischema = _.find(schema, v => v.name === o.name);
          return (
            <HStack key={i} width="100%">
              <OneFilterSelector
                ischema={ischema}
                rule={o}
                addOns={addOns}
                onFilterChange={(filter) => this._editFilter(filter, i)}
                style={{flex: 1}}
                typeIcon={typeIcon}
                />
              <XIconButton padding={5} onPress={() => this._removeFilter(i)}>
                {IconX.Get("muicom", "close-circle", 14, ColorX.CSS("greyOut"))}
              </XIconButton>
            </HStack>
          );
        })}
      </VStack>
    );
  }

  /**
   * 
   * @param {import("../__typedef").filterformat} format 
   */
  renderIcon(format){
    let size = 18;
    let color = ColorX.CSS("gambotBlue");
    return FilterizoIconX.Get(format, size, color);
  }

  renderAddBtn(mode){
    return (
      <XButton padding={3} onPress={this._openFieldSelector}
        bgColor={ColorX.CSS("transparent")}
        hoverBgColor={ColorX.CSS("pureDark", 0.05)}
        hoverColor={ColorX.CSS("gambotBlue")}
        color={ColorX.CSS("gambotBlue")}>
        {mode === "icon" ?
          <HStack>
            {IconX.Get("mui", "add-circle-outline", 18, ColorX.CSS("greyOut"))}
          </HStack>
          :
          <HStack width="auto">
            <XText style={styles.addfiltertextbtn}>
              {LocaleX.Parse({
                EN: "+ Add Rule...",
                TC: "+ 增加規則..."
              })}
            </XText>
          </HStack>
        }
      </XButton>
    );
  }

  renderANDORBtn(){
    let {filter} = this.state;
    return (
      <XButton padding={3} onPress={this._setAndOr} lockHeight={30}>
        <XText style={styles.andortext} numberOfLines={1}>
          {filter?.logic}
        </XText>
      </XButton>
    );
  }

  renderResetBtn(){
    return (
      <XButton padding={3} 
        onPress={this._clearFilter}
        bgColor={ColorX.CSS("transparent")}
        hoverBgColor={ColorX.CSS("pureDark", 0.05)}
        hoverColor={ColorX.CSS("gambotBlue")}
        color={ColorX.CSS("gambotBlue")}
        style={{height: 28}}>
        {IconX.Get("muicom", "filter-off", 18, ColorX.CSS("red"))}
      </XButton>
    );
  }

  renderFIMany(){
    let {filter, multiRules} = this.props;
    let {openAdv} = this.state;
    let numOfRules = filter?.rules.length;
    return (
      <VStack fullWidth flexShrink={0}>
        <HStack lockHeight={30}>
          <VStack flexGrow={1} lockHeight={30}>
            <HStack  lockHeight={30}>
              {multiRules && this.renderAddBtn("text")}
              <XButton onPress={this._openAdvFilter} 
                bgColor={ColorX.CSS("transparent")}
                hoverBgColor={ColorX.CSS("pureDark", 0.05)}
                hoverColor={ColorX.CSS("gambotBlue")}
                color={ColorX.CSS("gambotBlue")}
                style={{flex: 1, padding: 2}} lockHeight={30}>
                <HStack width="100%" spacing={5}>
                  <XText style={styles.manyFilterText}>
                    {LocaleX.Parse({
                      EN: `${numOfRules} rules`,
                      TC: `${numOfRules} 項規則`
                    })}
                  </XText>
                  {IconX.Get("ant", openAdv ? "caretup" : "caretdown", 12, ColorX.CSS("gambotBlue"))}
                </HStack>
              </XButton>
            </HStack>
          </VStack>
          {this.renderANDORBtn()}
          {this.renderResetBtn()}
        </HStack>
        {openAdv && this.renderAdvFilter()}
      </VStack>
    );
  }

  renderFIOne(){
    let {filter, addOns, schema, multiRules, typeIcon} = this.props;
    let onlyRule = filter?.rules[0];
    let ischema = _.find(schema, o => o.name === onlyRule.name);
    return (
      <HStack width={"100%"}>
        {multiRules && this.renderAddBtn("icon")}
        <HStack style={{ flex: 1, height: "100%" }}>
          <OneFilterSelector
            ischema={ischema}
            rule={onlyRule}
            addOns={addOns}
            onFilterChange={(filter) => this._editFilter(filter, 0)}
            typeIcon={typeIcon}
            />
        </HStack>
        {this.renderResetBtn()}
      </HStack>
    );
  }

  renderFINone(){
    return (
      <XButton onPress={this._openFieldSelector} 
        style={{width: "100%", padding: 2}}
        bgColor={ColorX.CSS("transparent")}
        hoverBgColor={ColorX.CSS("pureDark", 0.05)}
        hoverColor={ColorX.CSS("gambotBlue")}
        color={ColorX.CSS("gambotBlue")}>
        <HStack>
          <XText style={styles.noFilterText}>
            {LocaleX.Parse({
              EN: "+ Add Filter",
              TC: "篩選..."
            })}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderFullInner(){
    let {filter} = this.props;
    let {rules} = filter;
    if(rules?.length > 1){
      return this.renderFIMany();
    }else if(rules?.length === 1){
      return this.renderFIOne();
    }else{
      return this.renderFINone();
    }
  }

  renderFull(){
    let {style, bgColor, textColor, borderColor, borderWidth} = this.props;
    return (
      <HStack style={{...styles.container, ...style}} flexShrink={0}>
        <HStack spacing={5}
          bgColor={bgColor}
          bColor={borderColor}
          bW={borderWidth}
          pL={8} pR={5}
          fullWidth
          style={styles.inner}
          fitHeightToContent
          justifyContent={"flex-start"}>
          {IconX.Get("ionic", "filter", 16, textColor)}
          <HStack style={{width: "auto", flex: 1}} fitHeightToContent>
            {this.renderFullInner()}
          </HStack>
        </HStack>
      </HStack>
    );
  }

  renderMini(){

  }

  renderOnlyIcon(){

  }

  render(){
    let {displayMode} = this.props;
    switch(displayMode){
      case "onlyIcon": return this.renderOnlyIcon();
      case "mini": return this.renderMini();
      default: case "full": return this.renderFull();
    }
  }

}

export default Filterizo;
